import React from 'react';
import PropTypes from 'prop-types';

const BlogMobileFilterButton = ({ isOpen, onClick }) => (
  <button
    type="button"
    className="blog-mobile-filter-button bg-transparent border-0 flex-shrink-0 p-0"
    aria-label="Filter articles"
    aria-expanded={isOpen}
    onClick={onClick}
  >
    <svg width="42" height="25" viewBox="0 0 42 25" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect x="0.5" y="0.5" width="41" height="24" rx="12" stroke="#00737A" />
      <line x1="11" y1="9" x2="31" y2="9" stroke="#00737A" strokeWidth="2" />
      <line x1="11" y1="17" x2="31" y2="17" stroke="#00737A" strokeWidth="2" />
      <circle cx="25" cy="9" r="2.25" fill="white" stroke="#00737A" strokeWidth="1.5" />
      <circle cx="17" cy="17" r="2.25" fill="white" stroke="#00737A" strokeWidth="1.5" />
    </svg>
  </button>
);

BlogMobileFilterButton.propTypes = {
  isOpen: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

BlogMobileFilterButton.defaultProps = {
  isOpen: false,
};

export default BlogMobileFilterButton;
